


export class MainLastPublicationsByCategoriesView {
    constructor() {

    }

    render(state) { 

        if (!(state && Object.keys(state).length > 0)) { return;}

        const publications = state.data;

        const slides = document.querySelectorAll('.publication_categories .li.slide');
        slides.forEach((slide, index) => {

            const categoryData = publications[index];
            if (!categoryData) { return;}

            const titleSpan = slide.querySelector('.publication_category_title span');
            if (titleSpan) {
                titleSpan.textContent = categoryData.title;
            }

            const posts = slide.querySelectorAll('.post.dummy');
            posts.forEach((postEl, postIndex) => {
                const postData = categoryData.items[postIndex];
                if (!postData) { return;}

                postEl.classList.remove('dummy');

                const link = document.createElement('a');
                link.href = postData.url;
                link.textContent = postData.title;
                postEl.querySelector('.title').appendChild(link);


                const countersEl = postEl.querySelectorAll('.counters .ci');
                if (postData.counters?.likes) {

                    const b = document.createElement('b');
                    b.className = 'b';
                    b.dataset.tooltip = 'Likes';
                    if (postData.counters.likes.isActive) {
                        b.classList.add('active');
                    }

                    const span = document.createElement('span');
                    span.textContent = postData.counters.likes.count;

                    countersEl[0].classList.add('like');
                    countersEl[0].appendChild(b);
                    countersEl[0].appendChild(span);
                    
                }
                if (postData.counters?.views) {

                    const b = document.createElement('b');
                    b.className = 'b';
                    b.dataset.tooltip = 'Views';

                    const span = document.createElement('span');
                    span.textContent = postData.counters.views.value;

                    countersEl[1].classList.add('views');
                    countersEl[1].appendChild(b);
                    countersEl[1].appendChild(span);
                }

            });
        });
    }
}